// Spinner.tsx
import React from 'react';
import './styles/Spinner.module.css'; // Add your custom styles here

const Spinner = () => {
  return (
    <div className="spinner-overlay">
      <div className="spinner" />
    </div>
  );
};

export default Spinner;
